import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appDobFormat]'
})
export class DobFormatDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    let input = event.target.value.replace(/\D/g, ''); // Remove non-digits
    // Format as DD/MM/YYYY or DD-MM-YYYY
    const parts = [input.slice(0, 2), input.slice(2, 4), input.slice(4, 8)];

    event.target.value = parts.filter(Boolean).join('/'); // Use '-' for DD-MM-YYYY
    // If you need to update the model (ngModel) or form control value
    this.el.nativeElement.dispatchEvent(new Event('input')); // Trigger input event to update model
  }
}